import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const SearchResult = Record({
    label: null,
    value: null,
    image: null,
    subtitle: null,
    institutionId: null,
});

const NewPostState = Record({
    initiallyFetching: false,
    childrenQuery: null,
    fetchingSearchResults: false,
    searchResults: List(),
});

export default handleActions(
    {
        [Actions.initialFetch.type]: state => state.merge({initiallyFetching: true}),
        [Actions.initialFetchSuccess.type]: state => state.merge({initiallyFetching: false}),
        [Actions.initialFetchFailed.type]: state => state.merge({initiallyFetching: false}),
        [Actions.searchChildren.type]: (state, {payload}) =>
            state.merge({
                childrenQuery: payload.term,
                fetchingSearchResults: true,
            }),
        [Actions.searchChildrenSuccess.type]: (state, {payload}) =>
            state.merge({
                searchResults: state.searchResults
                    .toSet()
                    .union(
                        payload.searchResults
                            .map(
                                result =>
                                    new SearchResult({
                                        label: result.title,
                                        value: result.id,
                                        image: result.image,
                                        subtitle: result.subtitle,
                                        institutionId: result.meta.institutionId,
                                    }),
                            )
                            .toSet(),
                    )
                    .toList(),
                fetchingSearchResults: false,
            }),
        [Actions.searchChildrenAborted.type]: state =>
            state.merge({
                fetchingSearchResults: false,
            }),
        [Actions.searchChildrenFailed.type]: state =>
            state.merge({
                fetchingSearchResults: false,
            }),
    },
    new NewPostState(),
);
